import React from 'react'
import {BrowserRouter as Router,Routes,Route}from 'react-router-dom'
import Navbar from './components/Navbar/Navbar'
import Home from './components/Home'
import './App.css'
const App = () => {
  return <>
 < Router>
 <Navbar/>
 <Routes>
  <Route path='/' element={<Home/>} />
 </Routes>
 
 </Router>
  
  </>
}

export default App